import { useCopyToClipboard } from 'usehooks-ts';
import { Icon } from '~/components/granular/icon';
import { Tooltip } from '~/components/granular/tooltip';
import { useToast } from '~/global-state/toast';
import { useFormatMessage } from '~/intl';

export interface CopyButtonProps {
  text: string;
  tooltipText?: string;
}

export function CopyButton({ text, tooltipText }: CopyButtonProps) {
  const formatMessage = useFormatMessage();
  const { addToast } = useToast();

  const [_copiedText, copy] = useCopyToClipboard();

  const handleClick = () => {
    copy(text);
    addToast({ appearance: 'info', id: 'copy-to-clipboard', title: formatMessage({ id: 'common.copiedToClipboard' }) });
  };

  const button = (
    <button
      aria-label={formatMessage({ id: 'common.copyToClipboard' })}
      className="text-neutral-700 transition-colors hover:text-teal-700"
      onClick={handleClick}
      type="button"
    >
      <Icon height={16} icon="CopyIcon" width={16} />
    </button>
  );

  if (tooltipText) {
    return (
      <Tooltip trigger={button} className="z-20">
        {tooltipText}
      </Tooltip>
    );
  }

  return button;
}
